/**
 * What to call a page in the telemetry.
 *
 * The route name already is the name - it is unique by construction, and it
 * does not change when a company id or a tab does - so the only work here is
 * making it readable: 'portalV3' is on every portal route and says nothing, so
 * it comes off, and the rest is left exactly as router.js spells it.
 *
 * The public routes keep their names untouched, which matters: 'register' and
 * 'sbo' are the values the sign-up funnel filters on, and renaming either one
 * would empty it.
 *
 * This lives beside scrubUrl.js rather than in router.js so it can be tested
 * without importing the router, which pulls in every view in the portal.
 */
const PORTAL_PREFIX = 'portalV3';

export const pageName = (route) => {
  const name = route && route.name ? String(route.name) : '';
  if (!name) {
    // An unnamed or unmatched route. The path is scrubbed before it is sent.
    return route && route.path ? route.path : 'unknown';
  }
  if (name.startsWith(PORTAL_PREFIX)) {
    const rest = name.slice(PORTAL_PREFIX.length);
    return rest.charAt(0).toLowerCase() + rest.slice(1);
  }
  return name;
};

export default pageName;
